import { NgModule } from '@angular/core';
import { CardCircleChartComponent } from './card-circle-chart.component';
import { UniBoxModule } from '@unifonic/common';
import { UniLayoutModule } from "@unifonic/common";
import { UniTextModule } from "@unifonic/common";
import { LoadingMaskModule } from '../loading-mask/loading-mask.module';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [CardCircleChartComponent],
    exports: [CardCircleChartComponent],
    imports: [
        CommonModule,
        UniBoxModule,
        UniLayoutModule,
        UniTextModule,
        LoadingMaskModule
    ]
})
export class CardCircleChartModule { }